<template>
    <div>
        <b-card-text>
            <div class="mt-2 px-2">
                <validation-observer #default="{ invalid }">
                    <b-form @submit.prevent>
                        <div class="row">
                            <div class="col-md-6 mb-25">
                                <b-form-group label="نام" label-for="nameId">
                                    <validation-provider #default="{ errors }" name="نام" rules="required">
                                        <b-form-input v-model="form.Name_Fa"
                                            :state="errors.length > 0 ? false : null"></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </div>
                            <div class="col-md-6 mb-25">
                                <b-form-group label="نام انگلیسی" label-for="nameEnId">
                                    <b-form-input v-model="form.Name_En"></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-12 mb-25">
                                <b-form-group label="توضیحات" label-for="descriptionId">
                                    <b-form-textarea rows="3" no-resize dir="rtl" class="text-primary-middle"
                                        v-model="form.description"></b-form-textarea>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="d-flex justify-content-md-between align-items-center flex-md-row flex-column mt-1">
                            <div class="d-flex align-items-center">
                                <b-form-radio class="mr-2" v-model="selected" name="selection-mode" value="default">
                                    انتخاب آیکون
                                </b-form-radio>
                                <b-form-radio v-model="selected" name="selection-mode" value="upload">
                                    بارگذاری آیکون
                                </b-form-radio>
                            </div>
                            <b-button type="submit" variant="primary" @click="addCategories"
                                :disabled="invalid || loading" class="px-5 mt-3 mt-md-0 d-flex align-items-center">
                                <span>افزودن</span>
                                <b-spinner v-if="loading" class="ml-50" variant="white" small></b-spinner>
                            </b-button>
                        </div>
                        <div class="d-flex justify-content-center">
                            <div v-if="selected == 'upload'" class="mb-md-4 mt-md-3 my-3"
                                style="width: 250px;height: 250px;">
                                <div @click="selectFile" :class="{ 'upload-file': !imageBlob }"
                                    class="pointer d-flex justify-content-center align-items-center">
                                    <input @change.prevent="createFile" ref="fileInput" type="file" hidden />
                                    <div v-if="!imageBlob">
                                        <feather-icon size="95" icon="UploadCloudIcon" color="#7367f0f0" />
                                        <h5 class="text-primary mb-0">بارگذاری تصویر</h5>
                                    </div>
                                    <div v-if="imageBlob" class="categories-img">
                                        <b-img :src="imageBlob" class="object-fit-cover w-100 h-100"
                                            style="border-radius: 18px;" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="selected == 'default'" class="row my-3">
                            <div v-for="(item, index) in categoryIcons" :key="index"
                                class="col-6 col-xl-1 col-lg-2 col-md-4 mb-2">
                                <div @click="selectIcon(item.id)" class="bg-icon pointer rounded"
                                    :class="{ 'bg-active-icon': item.id == form.DefaultCategoryIconId }">
                                    <div class="d-flex justify-content-center">
                                        <div class="w-100 h-100">
                                            <img :src="BASE_URL_File + item.icon" class="w-100 h-100 object-fit-cover">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-form>
                </validation-observer>
            </div>
        </b-card-text>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BFormRadio, BForm, BFormInput, BFormFile, BFormGroup, BSpinner, BTable, BAvatar, BImg, BFormTextarea } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, min, max } from '@validations';
import Compressor from 'compressorjs';
import { storeService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormInput,
        BFormFile,
        BSpinner,
        BTable,
        BAvatar,
        BFormTextarea,
        BFormRadio,
        BImg,
        BFormGroup,
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            selected: 'default',
            required,
            min,
            max,
            storeId: null,
            file: null,
            loading: false,
            imageBlob: null,
            form: {
                Name_Fa: null,
                Name_En: null,
                description: null,
                DefaultCategoryIconId: null,
                CategoryIconImage: null,
            },
            categoryIcons: [],
            parameters: {
                pageIndex: 1,
                pageSize: 90
            }
        }
    },
    watch: {
        selected() {
            this.form.CategoryIconImage = null
            this.form.DefaultCategoryIconId = null
            this.imageBlob = null
        }
    },
    methods: {
        createFile(event) {
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            this.form.CategoryIconImage = result
                            if (this.form.CategoryIconImage) {
                                this.imageBlob = URL.createObjectURL(this.form.CategoryIconImage);
                            }
                        },
                    });
                }
                else {
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                }
            }
            else {
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
            }
        },
        getCategoryIconList() {
            storeService.categoryIconList(this.storeId, this.parameters).then(({ data }) => {
                this.categoryIcons = data.items
            })
        },
        selectIcon(id) {
            this.form.DefaultCategoryIconId = id
        },
        selectFile() {
            this.$refs['fileInput'].click();
        },
        addCategories() {
            this.loading = true;
            let formData = new FormData();
            formData.append("Name_Fa", this.form.Name_Fa)
            this.form.Name_En ? formData.append("Name_En", this.form.Name_En) : null
            this.form.description ? formData.append("description", this.form.description) : null
            this.form.DefaultCategoryIconId ? formData.append("DefaultCategoryIconId", this.form.DefaultCategoryIconId) : null
            this.form.CategoryIconImage ? formData.append("CategoryIconImage", this.form.CategoryIconImage, this.form.CategoryIconImage.name) : null
            storeService.createCategory(this.storeId, formData).then(({ data }) => {
                this.$emit('addCategories');
                this.$notif({ type: 'success', title: 'دسته‌بندی با موفقیت اضافه شد' });
            })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getCategoryIconList();
    },
};
</script>

<style lang="scss">
.upload-file {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='18' ry='18' stroke='%235E50EE95' stroke-width='4' stroke-dasharray='8%2c 16' stroke-dashoffset='15' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 18px;
    Width: 100%;
    height: 250px;
    margin: 0 0 0 0;
}

.categories-img {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 16px;
    width: 250px;
    height: 250px;
}

.bg-active-icon {
    background-color: rgb(0, 0, 0) !important;
    box-shadow: #7367f0 0px 0px 13px;
    border: 2px solid #7367f0 !important;
}

.bg-icon {
    background-color: rgb(42, 43, 48);
    border: 2px solid transparent;
}
</style>